import SlbPopUp from "../../controls/slbPopUp";
import { ComponentLoader } from "../../loader/componentLoader";

const _props = {
    show: false,
    title: '',
    message: ''

}

export function DocumentDownloadProgress(props = _props) {



    return <SlbPopUp className="saving_file_modal" hideHeader={true} hideFooter={true} show={props.show}>
        <div>
            <div className="file_modal_title">{props.title}</div>
            <div className="save-msg-longtime">
                <div>{props.message}</div>
            </div>
            <ComponentLoader />
        </div>
    </SlbPopUp>;

}